import * as React from "react";
import { IconCircleEllipsis } from "../icons/IconCircleEllipsis";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";


import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonEllipsis: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonOverflowH.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconCircleEllipsis fixedWidth />
        </MprcIconButton>
    );
};
